import { ScreenType } from '@accedo/one-plugin-sdk';

import { useDataContext } from '#/hooks/useDataContext';
import { PageController } from '#/pages/PageController';

import { useUnauthenticatedHomePage } from './UnauthenticatedHomePage.hook';

// This is intentionally hardcoded due to spec https://accedobroadband.jira.com/wiki/spaces/AccedoOne/pages/5284593756/Screen+views#Unauthenticated-homepage
const screenTitle = 'Unauthenticated Home';

export const UnauthenticatedHomePage = () => {
  const { pageId: unauthenticatedHomePageId } = useUnauthenticatedHomePage();
  const { getUnauthenticatedHomePageContext } = useDataContext();

  const defaultContext = getUnauthenticatedHomePageContext();

  return (
    <PageController
      defaultContext={defaultContext}
      pageId={unauthenticatedHomePageId}
      screenTitle={screenTitle}
      screenType={ScreenType.UnauthenticatedHome}
    />
  );
};
